import { Component, OnInit,  Input, ViewChild, EventEmitter, Output } from '@angular/core';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
    selector: 'gaweb-select-option-set-dialog',
    templateUrl: './select-option-set-dialog.component.html'
})
export class SelectOptionSetComponent implements OnInit {
    @ViewChild('childModal') public childModal: ModalDirective;
    @Output() onClose: EventEmitter<any> = new EventEmitter();
    @Input() data: Array<any>;
    selectedOptionType: any;
    injectedData: any;
    public config = {
        animated: true,
        keyboard: true,
        backdrop: false,
        ignoreBackdropClick: false
    };
    constructor() {
    }


    ngOnInit() {
    }

    onSelection(id: string, desc: string) {
        this.selectedOptionType = desc;
        this.onClose.emit({ id: id, desc: desc });
        this.hideModal();
    }

    showModal() {
        this.childModal.show();
    }
    hideModal() {
        this.childModal.hide();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/dialogs/select-option-set-dialog/select-option-set-dialog.component.ts